import React, { useEffect, useState } from "react";
import ShowTemperamentQuestion from "./ShowTemperamentQuestion";
import ShowValueQuestion from "./ShowValueQuestion";
import ShowIqQuestion from "./ShowIqQuestion";
import "./QuestionnaireTab.css";

const QuestionnaireTab = ({ onRequestProcessed }) => {
  const [selectedTab, setSelectedTab] = useState(1);

  useEffect(() => {
    if (onRequestProcessed) {
      setSelectedTab(1);
    }
  }, [onRequestProcessed]);

  return (
    <div className="questionnairecontainer">
      <div className="questionnairetabsContainer">
        <button
          className={`questionnairetabButton ${
            selectedTab === 1 ? "questionnaireselectedTab" : ""
          }`}
          onClick={() => setSelectedTab(1)}
        >
          Temperament
        </button>
        <button
          className={`questionnairetabButton ${
            selectedTab === 0 ? "questionnaireselectedTab" : ""
          }`}
          onClick={() => setSelectedTab(0)}
        >
          Values
        </button>
        <button
          className={`questionnairetabButton ${
            selectedTab === 2 ? "questionnaireselectedTab" : ""
          }`}
          onClick={() => setSelectedTab(2)}
        >
          IQ
        </button>
      </div>

      <div className="questionnairecontentContainer">
        {selectedTab === 1 ? (
          <ShowTemperamentQuestion />
        ) : selectedTab === 0 ? (
          <ShowValueQuestion />
        ) : (
          <ShowIqQuestion />
        )}
      </div>
    </div>
  );
};

export default QuestionnaireTab;
